import { render, staticRenderFns } from "./VerticalMenuSubItem.vue?vue&type=template&id=77a37462&"
import script from "./VerticalMenuSubItem.vue?vue&type=script&lang=js&"
export * from "./VerticalMenuSubItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports